import React from "react";

import styles from "../styles.scss";

export const EMPTY_IMAGE = "data:image/gif;base64,R0lGODdhDwAKAIAAAOgRMAAAACH5BAEAAAEALAAAAAAPAAoAAAIKjI+py+0Po5xUFgA7";

export default function EmptyFigure() {
  return (
    <figure className={styles["empty-figure"]}>
      <img src={EMPTY_IMAGE} alt="Empty" />
    </figure>
  );
}
